import React, { useEffect, useRef, useState } from "react";
import "./SocialMedia.scss";

const FbSvg = () => {
  return (
    <svg
      width="71"
      height="71"
      viewBox="0 0 71 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="fb">
        <path
          id="Vector"
          d="M69.8906 35.5C69.8906 16.502 54.498 1.10938 35.5 1.10938C16.502 1.10938 1.10938 16.502 1.10938 35.5C1.10938 52.6676 13.6855 66.8953 30.1334 69.4746V45.4428H21.3971V35.5H30.1334V27.923C30.1334 19.3045 35.2643 14.5439 43.1228 14.5439C46.8863 14.5439 50.8219 15.2151 50.8219 15.2151V23.6741H46.4842C42.2131 23.6741 40.8805 26.3255 40.8805 29.0448V35.5H50.4183L48.8929 45.4414H40.8805V69.4746C57.3131 66.8953 69.8906 52.6676 69.8906 35.5Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

const GhSvg = () => {
  return (
    <svg
      width="70"
      height="71"
      viewBox="0 0 70 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="gh" clip-path="url(#clip0_210_314)">
        <path
          id="Vector"
          d="M23.0881 55.1082C23.0881 55.3855 22.768 55.6074 22.3644 55.6074C21.9052 55.649 21.5851 55.4271 21.5851 55.1082C21.5851 54.8309 21.9052 54.609 22.3088 54.609C22.7263 54.5674 23.0881 54.7893 23.0881 55.1082ZM18.76 54.4842C18.6626 54.7615 18.9409 55.0805 19.3584 55.1637C19.7202 55.3023 20.1377 55.1637 20.2212 54.8863C20.3047 54.609 20.0403 54.29 19.6228 54.1652C19.261 54.0682 18.8574 54.2068 18.76 54.4842ZM24.9112 54.2484C24.5076 54.3455 24.2293 54.609 24.2711 54.9279C24.3128 55.2053 24.6746 55.3855 25.0922 55.2885C25.4957 55.1914 25.7741 54.9279 25.7323 54.6506C25.6906 54.3871 25.3148 54.2068 24.9112 54.2484ZM34.0685 1.10938C14.7658 1.10938 0 15.7115 0 34.9453C0 50.324 9.71399 63.484 23.5891 68.1156C25.3705 68.4346 25.9968 67.3391 25.9968 66.4377C25.9968 65.5779 25.955 60.8354 25.955 57.9232C25.955 57.9232 16.2132 60.0033 14.1674 53.7908C14.1674 53.7908 12.5809 49.7555 10.2985 48.7154C10.2985 48.7154 7.11153 46.5383 10.5212 46.5799C10.5212 46.5799 13.9865 46.8572 15.8931 50.1576C18.9409 55.5104 24.0484 53.9711 26.0385 53.0559C26.3586 50.8371 27.2632 49.2979 28.2652 48.3826C20.4857 47.5229 12.6365 46.3996 12.6365 33.0594C12.6365 29.2459 13.6942 27.3322 15.9209 24.8916C15.5591 23.9902 14.3761 20.2738 16.2828 15.4758C19.1914 14.5744 25.8854 19.2199 25.8854 19.2199C28.6688 18.4434 31.6609 18.0412 34.6252 18.0412C37.5895 18.0412 40.5817 18.4434 43.365 19.2199C43.365 19.2199 50.0591 14.5605 52.9677 15.4758C54.8743 20.2877 53.6914 23.9902 53.3295 24.8916C55.5562 27.3461 56.9201 29.2598 56.9201 33.0594C56.9201 46.4412 48.723 47.509 40.9435 48.3826C42.2238 49.4781 43.3094 51.5582 43.3094 54.817C43.3094 59.4902 43.2676 65.2729 43.2676 66.41C43.2676 67.3113 43.9078 68.4068 45.6752 68.0879C59.5921 63.484 69.0278 50.324 69.0278 34.9453C69.0278 15.7115 53.3713 1.10938 34.0685 1.10938ZM13.5272 48.9373C13.3463 49.076 13.388 49.3949 13.6246 49.6584C13.8473 49.8803 14.1674 49.9773 14.3483 49.7971C14.5292 49.6584 14.4875 49.3395 14.2509 49.076C14.0282 48.8541 13.7081 48.757 13.5272 48.9373ZM12.0242 47.8141C11.9268 47.9943 12.0659 48.2162 12.3443 48.3549C12.567 48.4936 12.8453 48.452 12.9427 48.2578C13.0401 48.0775 12.901 47.8557 12.6226 47.717C12.3443 47.6338 12.1216 47.6754 12.0242 47.8141ZM16.5333 52.7508C16.3106 52.9311 16.3941 53.3471 16.7142 53.6105C17.0343 53.9295 17.4379 53.9711 17.6188 53.7492C17.7997 53.5689 17.7162 53.1529 17.4379 52.8895C17.1317 52.5705 16.7142 52.5289 16.5333 52.7508ZM14.9467 50.7123C14.7241 50.851 14.7241 51.2115 14.9467 51.5305C15.1694 51.8494 15.5452 51.9881 15.7261 51.8494C15.9488 51.6691 15.9488 51.3086 15.7261 50.9897C15.5312 50.6707 15.1694 50.532 14.9467 50.7123Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_210_314">
          <rect width="69.0278" height="71" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const LinSvg = () => {
  return (
    <svg
      width="63"
      height="71"
      viewBox="0 0 63 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="lin" clip-path="url(#clip0_210_310)">
        <path
          id="Vector"
          d="M57.8004 4.4375H4.43229C1.98689 4.4375 0 6.44824 0 8.9166V62.0834C0 64.5518 1.98689 66.5625 4.43229 66.5625H57.8004C60.2458 66.5625 62.2466 64.5518 62.2466 62.0834V8.9166C62.2466 6.44824 60.2458 4.4375 57.8004 4.4375ZM18.8129 57.6875H9.58708V28.0395H18.8268V57.6875H18.8129ZM14.2 23.9902C11.2405 23.9902 8.85068 21.5912 8.85068 18.6514C8.85068 15.7115 11.2405 13.3125 14.2 13.3125C17.1456 13.3125 19.5493 15.7115 19.5493 18.6514C19.5493 21.6051 17.1595 23.9902 14.2 23.9902ZM53.3959 57.6875H44.1701V43.2656C44.1701 39.8266 44.1006 35.4029 39.3765 35.4029C34.5691 35.4029 33.8327 39.1471 33.8327 43.016V57.6875H24.6068V28.0395H33.4575V32.0887H33.5826C34.8192 29.759 37.8342 27.3045 42.3221 27.3045C51.6591 27.3045 53.3959 33.4477 53.3959 41.4352V57.6875Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_210_310">
          <rect width="62.2466" height="71" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const MailSvg = () => {
  return (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="mail">
        <path
          id="Vector"
          d="M7.8 59C6.52 59 5.4 58.5219 4.44 57.5656C3.48 56.6094 3 55.4937 3 54.2187V12.7812C3 11.5062 3.48 10.3906 4.44 9.43437C5.4 8.47812 6.52 8 7.8 8H62.2C63.48 8 64.6 8.47812 65.56 9.43437C66.52 10.3906 67 11.5062 67 12.7812V54.2187C67 55.4937 66.52 56.6094 65.56 57.5656C64.6 58.5219 63.48 59 62.2 59H7.8ZM35 34.9344L7.8 17.1641V54.2187H62.2V17.1641L35 34.9344ZM35 30.1531L61.88 12.7812H8.2L35 30.1531ZM7.8 17.1641V12.7812V54.2187V17.1641Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

const TwSvg = () => {
  return (
    <svg
      width="71"
      height="71"
      viewBox="0 0 71 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="tw" clip-path="url(#clip0_210_312)">
        <path
          id="Vector"
          d="M63.7063 21.0365C63.7514 21.6672 63.7514 22.298 63.7514 22.9294C63.7514 42.1632 49.1076 64.3368 22.3439 64.3368C14.0999 64.3368 6.43828 61.9489 0.00390625 57.804C1.17527 57.939 2.3017 57.9841 3.51785 57.9841C10.3211 57.9841 16.5821 55.6863 21.5868 51.7674C15.1899 51.6322 9.82881 47.4423 7.9817 41.6763C8.88279 41.8113 9.78305 41.9015 10.7302 41.9015C12.0366 41.9015 13.3428 41.7212 14.5589 41.406C7.89156 40.0544 2.89105 34.1978 2.89105 27.2476V27.0675C4.8283 28.1487 7.08033 28.8244 9.46826 28.9146C5.54939 26.302 2.98119 21.8409 2.98119 16.7961C2.98119 14.0933 3.70187 11.6153 4.96281 9.45337C12.1252 18.2826 22.8931 24.0555 34.9714 24.6795C34.7462 23.5983 34.611 22.4719 34.611 21.3459C34.611 13.3265 41.0981 6.79919 49.1577 6.79919C53.3469 6.79919 57.1313 8.55617 59.7896 11.3948C63.0789 10.7641 66.2323 9.54767 69.0252 7.88084C67.9438 11.2603 65.6458 14.0975 62.6283 15.9002C65.557 15.585 68.3942 14.7739 71.0082 13.6482C69.0266 16.5312 66.5485 19.0994 63.7099 21.1711L63.7063 21.0365Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_210_312">
          <rect width="71" height="71" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

function SocialMedia() {
  const redirectTo = (id: string) => {
    switch (id) {
      case "FbSvg":
        window.open("https://www.facebook.com/mihai.cira.7", "_blank");
        break;
      case "GhSvg":
        window.open("https://github.com/mihaiciradev", "_blank");
        break;
      case "LinSvg":
        window.open("https://www.linkedin.com/in/mihaicira/", "_blank");
        break;
      case "MailSvg":
        window.location.href = "mailto:mihai.cira.dev@gmail.com";
        break;
      case "TwSvg":
        window.open("https://twitter.com/mihai291291", "_blank");
        break;
    }
  };

  return (
    <div id="socialMediaContainer">
      <button
        onClick={() => {
          redirectTo("FbSvg");
        }}
      >
        <FbSvg />
      </button>
      <button
        onClick={() => {
          redirectTo("GhSvg");
        }}
      >
        <GhSvg />
      </button>
      <button
        onClick={() => {
          redirectTo("MailSvg");
        }}
      >
        <MailSvg />
      </button>
      <button
        onClick={() => {
          redirectTo("LinSvg");
        }}
      >
        <LinSvg />
      </button>
      <button
        onClick={() => {
          redirectTo("TwSvg");
        }}
      >
        <TwSvg />
      </button>
    </div>
  );
}

export default SocialMedia;
